import { get } from 'lodash'
import Link from 'next/link'
import React from 'react'
import { ROUTE } from 'shared-constants'
import { Button } from 'components/Button'
import Icon from 'components/Icon/Icon'
import { ICON_BADGE_INTENT, IconBadge } from 'components/IconBadge'
import { Flex } from 'components/Layout'
import { useCart } from 'providers/cart'
import { SPACE } from 'Theme'

const ICON_BADGE_MAX = 99

export const ShopNavSection = () => {
  const { cart } = useCart()
  const cartItemsCount = get(cart, ['summary', 'itemsCount'], 0)
  return (
    <Flex gap={SPACE.PX_10} alignItems="center">
      <Link href={ROUTE.SHOWROOM()}>
        <Button>Shop now</Button>
      </Link>
      <Link href={ROUTE.SHOWROOM_CART()} aria-label="Go to cart">
        <Button variant="outline" width="initial" px={SPACE.PX_6}>
          <IconBadge
            content={cartItemsCount}
            intent={ICON_BADGE_INTENT.DANGER}
            max={ICON_BADGE_MAX}
          >
            <Icon.CartDashboard />
          </IconBadge>
        </Button>
      </Link>
    </Flex>
  )
}
